// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"61":"ArticlesView","182":"AuthorsView","200":"TopicsView","899":"ArticleDetailView","909":"SponsorsView"}[chunkId] + "." + {"61":"821400c7","182":"821400c7","200":"821400c7","899":"9e676452","909":"821400c7"}[chunkId] + ".css";
};